import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState, } from 'react';
import AccordionButton from './AccordionButton';
import AccordionContext from './AccordionContext';
import AccordionItem from './AccordionItem';
import AccordionPanel from './AccordionPanel';
const Accordion = ({ as, defaultActiveItem = '', children, ...restProps }) => {
    const [activeItem, setActiveItem] = useState(defaultActiveItem);
    const changeSelectedItem = useCallback((value) => {
        if (activeItem !== value)
            setActiveItem(value);
    }, [setActiveItem, activeItem]);
    const Component = as || 'div';
    return (_jsx(AccordionContext.Provider, { value: { activeItem, changeSelectedItem }, children: _jsx(Component, { ...restProps, children: children }) }));
};
Accordion.Item = AccordionItem;
Accordion.Panel = AccordionPanel;
Accordion.Button = AccordionButton;
export default Accordion;
